import * as React from 'react'

import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'

import kugelMittelSVG from '../../assets/kugel-mittlere-lagen.svg'

import styled from 'styled-components'
import kugelDeckelSVG from '../../assets/kugel-deckel.svg'
import SnowAnimator from 'components/Snow/SnowAnimator'
import './styles.scss'

const SnowAnimationContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  /* background-color: green; */
  mask-image: url(${({ maskImage }) => maskImage});
  mask-repeat: no-repeat;
  mask-size: contain;
`
const SnowAnimation = styled.div``

export default class MittlereLagen extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <TextWidth>
        <div className='content' style={{ textAlign: 'center' }}>
          <div className='ui text container category first'>
            <div className='content-wrapper'>
              <div className='category content mittel'>
                <span className='category title mittel'>{this.props.languageContent.mittlereLagen.title}</span>
                <span className='category hoehe mittel'>{this.props.languageContent.mittlereLagen.altitude}</span>
              </div>

              <div className='coverContent' id='coverDetail'>
                <div className='coverTextWrapper mittel'>
                  <div className='coverProzent mittel'>{this.props.languageContent.mittlereLagen.percent}</div>
                  <div className='coverText mittel'>{this.props.languageContent.mittlereLagen.unit}</div>
                  <div className='triangle mittel'></div>
                </div>

                <div className='animation-container'>
                  <SnowAnimationContainer
                    maskImage={kugelDeckelSVG}
                    className={'hoch'}
                  >
                    <SnowAnimator snowflakeCount={120} />
                  </SnowAnimationContainer>
                  <img src={kugelMittelSVG} alt='Schneekugel' />
                </div>
              </div>

              <div className='list mittel'>
                <ul>
                  <li dangerouslySetInnerHTML={{__html: this.props.languageContent.mittlereLagen.metrics[0]}}></li>
                  <li dangerouslySetInnerHTML={{__html: this.props.languageContent.mittlereLagen.metrics[1]}}></li>
                  <li dangerouslySetInnerHTML={{__html: this.props.languageContent.mittlereLagen.metrics[2]}}></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </TextWidth>
    )
  }
}
